import {useState, useEffect, useRef} from 'react';
import {FormattedMessage} from 'react-intl';
import NoResults from 'shared/components/searchable_dropdown/NoResults';
import _ from 'lodash';
import Suggestion from 'shared/components/searchable_dropdown/suggestions/Suggestion';

const DropdownList = ({
                        sections = [],
                        query = '',
                        selectedIndex = -1,
                        onClose,
                        onSelect
                      }) => {
  const [animationStatus, setAnimationStatus] = useState('is-open');
  const containerRef = useRef(null);
  const mountedRef = useRef(true);

  useEffect(() => {
    mountedRef.current = true;

    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        if (mountedRef.current) {
          setAnimationStatus('is-closed');
          setTimeout(() => {
            if (mountedRef.current && onClose) {
              onClose();
            }
          }, 400);
        }
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
      mountedRef.current = false;
    };
  }, [onClose]);

  const handleItemClick = (item) => {
    if (onSelect) {
      onSelect(item);
    }
  };

  let globalIndex = 0;

  return (
    <div
      ref={containerRef}
      className={`searchable-dropdown-list ${animationStatus}`.trim()}
    >
      <div className='bg-white rounded box-shadow-2 border'>
        {_.isEmpty(sections) ?
          <NoResults query={query}/> :
          sections.map((section) => (
            <div key={section.caption}>
              <div className='border-bottom'>
                <div className='searchable-dropdown-section'>
                  <FormattedMessage id={`global_search.sections.${section.caption}`}/>
                </div>
              </div>
              <div>
                {section.suggestionViewModels.map(item => {
                  const currentIndex = globalIndex++;
                  const isSelected = currentIndex === selectedIndex;
                  return (
                    <div key={item.data.id} onClick={() => handleItemClick(item)}>
                      <Suggestion
                        viewModel={{...item, selected: isSelected}}
                        query={query}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default DropdownList;
